// extracted by mini-css-extract-plugin
module.exports = {"page":"page_page__fWmUX","breadcrumbsContainer":"page_breadcrumbsContainer__ZgRFU","main":"page_main__yu0oU"};